

























import Vue from 'vue'
import drawer from './drawer.vue'
import { cloneDeep } from 'lodash'
import { columnsEvent } from './data'
import { IotAppEventServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'

const aesp = new IotAppEventServiceProxy()

export default Vue.extend({
  props: ['app', 'gatewayCode'],
  components: { drawer },
  data() {
    return {
      dataList: [],
      visible: false,
      loading: false
    }
  },
  computed: {
    columnsEvent() {
      return columnsEvent.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    drawerTitle() {
      if (this.app) {
        return this.app.name + this.$t('page_log_management_action')
      } else {
        return ''
      }
    }
  },
  methods: {
    showDrawer() {
      this.visible = true
      this.getList()
    },
    onClose() {
      this.visible = false
    },
    async getList() {
      this.dataList = []
      if (!this.app || !this.gatewayCode) {
        return
      }
      this.loading = true
      try {
        let { items } = await aesp.getIotAppEventList(this.app.code, this.gatewayCode)
        this.dataList = cloneDeep(items)
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    refresh() {
      this.getList()
    }
  }
})
